import React from 'react'


const LandingPage = () => {

  return (
    <div className="relative overflow-hidden h-full">
      {/* Subtle Grid Background */}
      <div className="absolute inset-0 opacity-5">
        <div 
          className="absolute inset-0 bg-grid-white-500/10"
          style={{
            backgroundImage: `
              linear-gradient(rgba(255, 255, 255, 0.1) 1px, transparent 1px),
              linear-gradient(90deg, rgba(255, 255, 255, 0.1) 1px, transparent 1px)
            `,
            backgroundSize: '20px 20px'
          }}
        />
      </div>

      {/* Main Content - Full Width, No Borders */}
      <main className="relative z-10 flex flex-col items-center justify-center min-h-[calc(100vh-200px)] px-6 text-center">
        {/* Welcome Message */}
        <div className="mb-12">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-6 tracking-widest uppercase">
            WELCOME TO
          </h1>
          
          <div className="relative mb-8">
            <h2 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white tracking-widest uppercase mb-6">
              THE LAUNCH PAD
            </h2>
            
            {/* First Row - 3 Equal Size Colored Lines (Red, Yellow, Blue) */}
            <div className="flex justify-center gap-2 mb-4">
              <div className="w-24 h-1 bg-red-500"></div>
              <div className="w-24 h-1 bg-yellow-500"></div>
              <div className="w-24 h-1 bg-blue-500"></div>
            </div>
          </div>
          
          <p className="text-xl md:text-2xl lg:text-3xl text-white font-light tracking-widest uppercase">
            SPACE IS BETTER TOGETHER
          </p>
        </div>
      </main>
    </div>
  )
}

export default LandingPage